module.exports = __webpack_public_path__ + "static/media/ZoomIn3.svg";